
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies",
      function () {
        return require("private-next-pages/cookies/index.tsx");
      }
    ]);
  